import { useEffect, useState } from 'react';

/** Debounces a value by `ms` so search-as-you-type doesn't fire a
 *  network request on every keystroke. */
export function useDebouncedValue<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = globalThis.setTimeout(() => setDebounced(value), ms);
    return () => globalThis.clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
